import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  Byte: any;
  /**
   * The `Date` scalar type represents a year, month and day in accordance with the
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard.
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a date and time. `DateTime` expects
   * timestamps to be formatted in accordance with the
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard.
   */
  DateTime: any;
  /**
   * The `DateTimeOffset` scalar type represents a date, time and offset from UTC.
   * `DateTimeOffset` expects timestamps to be formatted in accordance with the
   * [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard.
   */
  DateTimeOffset: any;
  Decimal: any;
  Guid: any;
  Long: any;
  /** The `Milliseconds` scalar type represents a period of time represented as the total number of milliseconds. */
  Milliseconds: any;
  SByte: any;
  /** The `Seconds` scalar type represents a period of time represented as the total number of seconds. */
  Seconds: any;
  Short: any;
  UInt: any;
  ULong: any;
  UShort: any;
  Uri: any;
};




export type AttributeMapping = {
  attributeMappingID?: Maybe<Scalars['Int']>;
  attributeType?: Maybe<AttributeType>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  element?: Maybe<Element>;
  elementCategory?: Maybe<ElementCategory>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  normalizationFunctionCode?: Maybe<Scalars['String']>;
  normalizationFunctionParam?: Maybe<Scalars['String']>;
  propertySet?: Maybe<Scalars['String']>;
  propertySetAttribute?: Maybe<Scalars['String']>;
  targetAttributeName?: Maybe<Scalars['String']>;
};

export type AttributeRole = {
  attributeRoleID?: Maybe<Scalars['Int']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  elementAttribute?: Maybe<ElementAttribute>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Role>;
  roleType?: Maybe<AttributeRoleType>;
};

/** Type of role of attribute. */
export enum AttributeRoleType {
  /** Editable. */
  VIEW = 'VIEW',
  /** View only. */
  EDIT = 'EDIT'
}

export type AttributeType = {
  attributeTypeID?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  dataType?: Maybe<DataType>;
  isReferenceUnit?: Maybe<Scalars['Boolean']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  projectAttributes: Array<ProjectAttribute>;
  unit?: Maybe<Scalars['String']>;
};


export type AttributeTypeProjectAttributesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};



/** Category related equipment. */
export type CategoryEquipment = {
  /** Category Equipment identifier. */
  categoryEquipmentID?: Maybe<Scalars['Int']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  elementCategory?: Maybe<ElementCategory>;
  equipment?: Maybe<Equipment>;
  /** Komponenten Menge - Number of pcs per unit. */
  kMenge?: Maybe<Scalars['Float']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Sorting order. */
  sortOrder?: Maybe<Scalars['Int']>;
};

/** Category related material. */
export type CategoryMaterial = {
  /** Material identifier. */
  categoryMaterialID?: Maybe<Scalars['Int']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  elementCategory?: Maybe<ElementCategory>;
  /** Komponenten Menge - Number of pcs per unit. */
  kMenge?: Maybe<Scalars['Float']>;
  material?: Maybe<Material>;
  /** Material type. */
  materialType?: Maybe<MaterialType>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Sorting order. */
  sortOrder?: Maybe<Scalars['Int']>;
};

/** Represents single row in category filter */
export type CategoryReport = {
  attributeType?: Maybe<AttributeType>;
  children?: Maybe<Array<Maybe<CategoryReport>>>;
  elementCategory?: Maybe<ElementCategory>;
  extraCharge?: Maybe<Scalars['Float']>;
  geab?: Maybe<Scalars['String']>;
  instancesPerFileVersionViewable?: Maybe<Array<Maybe<ProjectFileVersionViewableInstances>>>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Float']>;
  workNo?: Maybe<Scalars['String']>;
};

/** Category related work. */
export type CategoryWork = {
  /** Material identifier. */
  categoryWorkID?: Maybe<Scalars['Int']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  elementCategory?: Maybe<ElementCategory>;
  /** Komponenten Menge - Number of pcs per unit. */
  kMenge?: Maybe<Scalars['Float']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Sorting order. */
  sortOrder?: Maybe<Scalars['Int']>;
  work?: Maybe<Work>;
};

export enum ComparisonGraph {
  contains = 'contains',
  endsWith = 'endsWith',
  equal = 'equal',
  greaterThan = 'greaterThan',
  greaterThanOrEqual = 'greaterThanOrEqual',
  notIn = 'notIn',
  in = 'in',
  lessThan = 'lessThan',
  lessThanOrEqual = 'lessThanOrEqual',
  like = 'like',
  startsWith = 'startsWith'
}

export enum Connector {
  AND = 'AND',
  OR = 'OR',
  and = 'and',
  or = 'or'
}

/** Represents whole report per categories */
export type CostReport = {
  categories?: Maybe<Array<Maybe<CategoryReport>>>;
  priceAttributeType?: Maybe<AttributeType>;
  totalAmount?: Maybe<Scalars['Float']>;
};

export type Currency = {
  alpha3Code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  currencyID?: Maybe<Scalars['Int']>;
  displayFormat?: Maybe<Scalars['String']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
};

/** Type of dashboard. */
export enum DashboardType {
  /** IstSoll. */
  IST_SOLL = 'IST_SOLL',
  /** Single column. */
  SINGLE_COLUMN = 'SINGLE_COLUMN'
}

export type DataModel = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  dataModelID?: Maybe<Scalars['Int']>;
  elements: Array<Element>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  relationTrees: Array<RelationTree>;
  specialInstances: Array<SpecialModelInstance>;
};


export type DataModelElementsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type DataModelRelationTreesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type DataModelSpecialInstancesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

/** Data types for project / element attributes. */
export enum DataType {
  /** String. */
  STRING = 'STRING',
  /** Boolean. */
  BOOLEAN = 'BOOLEAN',
  /** Date without time. */
  DATE = 'DATE',
  /** Date with time. */
  DATE_TIME = 'DATE_TIME',
  /** Integer. */
  INT = 'INT',
  /** Double. */
  DOUBLE = 'DOUBLE',
  /** Url. */
  LINK = 'LINK'
}





/** Derived position entity. */
export type DerivedCategory = {
  conditionalRule?: Maybe<LookupRule>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Derived category identifier. */
  derivedCategoryID?: Maybe<Scalars['Int']>;
  /** Derived position mapping type. */
  derivedPositionMappingType?: Maybe<DerivedPositionMappingType>;
  elementCategoryFrom?: Maybe<ElementCategory>;
  elementCategoryTo?: Maybe<ElementCategory>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  referenceAttributeMapping?: Maybe<AttributeMapping>;
  /** Sorting order. */
  sortOrder?: Maybe<Scalars['Int']>;
};

/** Mapping type of derived position. */
export enum DerivedPositionMappingType {
  /** One unit. */
  ONE_UNIT = 'ONE_UNIT',
  /** Equal units. */
  EQUAL_UNITS = 'EQUAL_UNITS',
  /** Mapping. */
  MAPPING = 'MAPPING',
  /** Free form. */
  FREE_FORM = 'FREE_FORM'
}

/** Element represents categorization of instances per datamodel. Element category assigned to model. */
export type Element = {
  attributes: Array<ElementAttribute>;
  attributesMapping: Array<AttributeMapping>;
  /**
   * Full element code
   *
   * Containing full category structure code, only for performance
   */
  code?: Maybe<Scalars['String']>;
  /**
   * Element code suffix
   *
   * Suffix will be prepended all category structure codes
   */
  codeSuffix?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  dataModel?: Maybe<DataModel>;
  elementAttribute?: Maybe<ElementAttribute>;
  elementCategory?: Maybe<ElementCategory>;
  /** Element identifier. */
  elementID?: Maybe<Scalars['Int']>;
  elementPrices: Array<ElementPrice>;
  /** Element tag. */
  elementTag?: Maybe<ElementTagType>;
  instances: Array<Instance>;
  lookupRule?: Maybe<LookupRule>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /**
   * Element name
   *
   * Name of the element
   */
  name?: Maybe<Scalars['String']>;
  priceSource?: Maybe<PriceSource>;
  /**
   * Priority
   *
   * Priority of the element
   */
  priority?: Maybe<Scalars['Int']>;
};


/** Element represents categorization of instances per datamodel. Element category assigned to model. */
export type ElementAttributesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Element represents categorization of instances per datamodel. Element category assigned to model. */
export type ElementAttributesMappingArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Element represents categorization of instances per datamodel. Element category assigned to model. */
export type ElementElementPricesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Element represents categorization of instances per datamodel. Element category assigned to model. */
export type ElementInstancesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type ElementAttribute = {
  attributeRoles: Array<AttributeRole>;
  attributeType?: Maybe<AttributeType>;
  /**
   * Element attribute code
   *
   * Alphanumeric attribute code
   */
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  element?: Maybe<Element>;
  elementAttributeID?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  multiplicityLimit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Int']>;
};


export type ElementAttributeAttributeRolesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type ElementAttributeValue = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  elementAttribute?: Maybe<ElementAttribute>;
  elementAttributeValueID?: Maybe<Scalars['Int']>;
  elementInstance?: Maybe<Instance>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
};

export type ElementCategory = {
  attributesMapping: Array<AttributeMapping>;
  categoryMaterials: Array<CategoryMaterial>;
  categoryWork: Array<CategoryWork>;
  childElementCategories: Array<ElementCategory>;
  code?: Maybe<Scalars['String']>;
  codeSuffix?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  derivedCategories: Array<DerivedCategory>;
  description?: Maybe<Scalars['String']>;
  din276Structure?: Maybe<Scalars['String']>;
  element: Array<Element>;
  elementCategoryID?: Maybe<Scalars['Int']>;
  graphics?: Maybe<Graphics>;
  isCustom?: Maybe<Scalars['Boolean']>;
  isFromEbkpCatalogue?: Maybe<Scalars['Boolean']>;
  isInstantiable?: Maybe<Scalars['Boolean']>;
  isManual?: Maybe<Scalars['Boolean']>;
  longText?: Maybe<Scalars['String']>;
  lookupRule?: Maybe<LookupRule>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  omniclass?: Maybe<Scalars['String']>;
  parentElementCategory?: Maybe<ElementCategory>;
  prices: Array<ElementPrice>;
  priceSource?: Maybe<PriceSource>;
  /** Element pricing type. */
  pricingType?: Maybe<ElementCategoryPricingType>;
  projectCategories: Array<ProjectCategory>;
  referenceUnit?: Maybe<AttributeType>;
  /** Explanation. */
  shortText?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  /** Entity state. */
  state?: Maybe<EntityStatus>;
  stlbBauCode?: Maybe<Scalars['String']>;
  /** Element category type. */
  type?: Maybe<ElementCategoryType>;
  /** Temporary place where to store category unit price - change to something like ElementPrice. */
  unitPrice?: Maybe<Scalars['Float']>;
};


export type ElementCategoryAttributesMappingArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ElementCategoryCategoryMaterialsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ElementCategoryCategoryWorkArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ElementCategoryChildElementCategoriesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ElementCategoryDerivedCategoriesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ElementCategoryElementArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ElementCategoryPricesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ElementCategoryProjectCategoriesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

/** Element category type. */
export enum ElementCategoryPricingType {
  /** Calculated price. */
  CALCULATED = 'CALCULATED',
  /** Subcontractor position. */
  SUBCONTRACTOR = 'SUBCONTRACTOR'
}

/** Element category type. */
export enum ElementCategoryType {
  /** Model position. */
  MODEL = 'MODEL',
  /** Manual position. */
  MANUAL = 'MANUAL',
  /** Derived position. */
  DERIVED = 'DERIVED'
}

export type ElementPrice = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Currency>;
  element?: Maybe<Element>;
  elementCategory?: Maybe<ElementCategory>;
  elementPriceID?: Maybe<Scalars['Int']>;
  /**
   * Valid flag
   *
   * Simple representation of validity
   */
  isValid?: Maybe<Scalars['Boolean']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  previousElementPrice?: Maybe<ElementPrice>;
  priceSource?: Maybe<PriceSource>;
  surcharge?: Maybe<Scalars['Float']>;
  /**
   * Valid from
   *
   * The begining of the valid period
   */
  validFrom?: Maybe<Scalars['DateTime']>;
  /**
   * Valid to
   *
   * The end of the valid period, null if no end of the valid period
   */
  validTo?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Float']>;
};

export enum ElementTagType {
  NOT_INCLUDED = 'NOT_INCLUDED',
  NORMAL = 'NORMAL',
  UNCATEGORIZED = 'UNCATEGORIZED'
}

/** Entity status. */
export enum EntityStatus {
  /** Active. */
  ACTIVE = 'ACTIVE',
  /** Voided. */
  VOIDED = 'VOIDED'
}

/** Equipment definition. */
export type Equipment = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Equipment identifier. */
  equipmentID?: Maybe<Scalars['Int']>;
  /** Artikel Nr. o. G TIN. */
  itemNumber?: Maybe<Scalars['String']>;
  /** Listen Preis - List price. */
  liPrice?: Maybe<Scalars['Float']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Produkt ID. */
  productID?: Maybe<Scalars['String']>;
  /** Produkt Name. */
  productName?: Maybe<Scalars['String']>;
  /** Zuschlag in percent. */
  surcharge?: Maybe<Scalars['Float']>;
};

export type ExternalSystem = {
  code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  externalSystemID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  projectExternals: Array<ProjectExternal>;
  projectFileExternals: Array<ProjectFileExternal>;
  projectFileVersionExternals: Array<ProjectFileVersionExternal>;
  projectFileVersionViewableExternals: Array<ProjectFileVersionViewableExternal>;
  sensorAssemblyGeometryExternals: Array<SensorAssemblyGeometryExternal>;
  sensorAssemblyItemExternals: Array<SensorAssemblyItemExternal>;
  sensorLocationExternals: Array<SensorLocationExternal>;
  url?: Maybe<Scalars['String']>;
};


export type ExternalSystemProjectExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ExternalSystemProjectFileExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ExternalSystemProjectFileVersionExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ExternalSystemProjectFileVersionViewableExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ExternalSystemSensorAssemblyGeometryExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ExternalSystemSensorAssemblyItemExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ExternalSystemSensorLocationExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

/** Revit Family. */
export type Family = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  familyExternals: Array<FamilyExternal>;
  /** Numerical identifier */
  familyID?: Maybe<Scalars['Int']>;
  /** Family name */
  familyName?: Maybe<Scalars['String']>;
  /** Latest Version Author System */
  latestVersionAuthorSystem?: Maybe<Scalars['String']>;
  /** Latest Version Author User */
  latestVersionAuthorUser?: Maybe<Scalars['String']>;
  /** Latest Version */
  latestVersionString?: Maybe<Scalars['String']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
};


/** Revit Family. */
export type FamilyFamilyExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

/** Revit Family external data. */
export type FamilyExternal = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  externalSystem?: Maybe<ExternalSystem>;
  family?: Maybe<Family>;
  /** Family External ID. */
  familyExternalID?: Maybe<Scalars['Int']>;
  /** Latest Version external ID. */
  latestVersionExternalID?: Maybe<Scalars['String']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
};

export type FileType = {
  code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  fileTypeID?: Maybe<Scalars['Int']>;
  isModel?: Maybe<Scalars['Boolean']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  projectFiles: Array<ProjectFile>;
};


export type FileTypeProjectFilesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

/** String filter condition type. */
export enum FilterCondition {
  /** Filter condition 'contains'. */
  CONTAINS = 'CONTAINS',
  /** Filter condition 'equals'. */
  EQUALS = 'EQUALS',
  /** Filter condition 'startswith'. */
  STARTS_WITH = 'STARTS_WITH',
  /** Filter condition 'isdefined'. */
  IS_DEFINED = 'IS_DEFINED'
}

/** Graphical properties. */
export type Graphics = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Cut Background. */
  cutBackground?: Maybe<Scalars['String']>;
  cutBackgroundPattern?: Maybe<GraphicsPattern>;
  /** Cut Foreground. */
  cutForeground?: Maybe<Scalars['String']>;
  cutForegroundPattern?: Maybe<GraphicsPattern>;
  /** Graphics identifier. */
  graphicsID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Graphics name. */
  name?: Maybe<Scalars['String']>;
  /** Shading. */
  shading?: Maybe<Scalars['String']>;
  /** Surface Background. */
  surfaceBackground?: Maybe<Scalars['String']>;
  surfaceBackgroundPattern?: Maybe<GraphicsPattern>;
  /** Surface Foreground. */
  surfaceForeground?: Maybe<Scalars['String']>;
  surfaceForegroundPattern?: Maybe<GraphicsPattern>;
  /** Transparency. */
  transparency?: Maybe<Scalars['Int']>;
};

/** Graphical pattern. */
export type GraphicsPattern = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Pattern identifier. */
  graphicsPatternID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Pattern name. */
  name?: Maybe<Scalars['String']>;
};


/** Ignored revit category. */
export type IgnoredRevitCategory = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Ignored revit category identifier. */
  ignoredRevitCategoryID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  project?: Maybe<Project>;
  revitCategory?: Maybe<RevitCategory>;
};

export type Instance = {
  attributeValues: Array<ElementAttributeValue>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  element?: Maybe<Element>;
  followingInstance?: Maybe<Instance>;
  globalID?: Maybe<Scalars['String']>;
  instanceExternals: Array<InstanceExternal>;
  instanceID?: Maybe<Scalars['Int']>;
  instanceInViewables: Array<InstanceInViewable>;
  instanceRelations1: Array<InstanceRelation>;
  instanceRelations2: Array<InstanceRelation>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  previousInstance?: Maybe<Instance>;
  projectFileVersion?: Maybe<ProjectFileVersion>;
  projectFileVersionViewable?: Maybe<ProjectFileVersionViewable>;
};


export type InstanceAttributeValuesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type InstanceInstanceExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type InstanceInstanceInViewablesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type InstanceInstanceRelations1Args = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type InstanceInstanceRelations2Args = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type InstanceExternal = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  externalID?: Maybe<Scalars['String']>;
  externalSystem?: Maybe<ExternalSystem>;
  instance?: Maybe<Instance>;
  instanceExternalID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
};

/** Instance in Viewable represents M:N relationship between Instance and ProjectFileVersionViewable. */
export type InstanceInViewable = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  instance?: Maybe<Instance>;
  /** InstanceInViewable Identifier. */
  instanceInViewableID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  projectFileVersionViewable?: Maybe<ProjectFileVersionViewable>;
};

export type InstanceRelation = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  instance1?: Maybe<Instance>;
  instance2?: Maybe<Instance>;
  instanceRelationID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  relationDefinition?: Maybe<RelationDefinition>;
};

/** Bim 360 issue. */
export type Issue = {
  /**
   * Permitted statuses transitions
   *
   * Stauses which current issue can be moved to
   */
  allowedStatuses?: Maybe<Array<IssueStatus>>;
  /**
   * Assigned to
   *
   * User the issue is assigned to
   */
  assignedTo?: Maybe<User>;
  /** Unique issue code */
  code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Issue description */
  description?: Maybe<Scalars['String']>;
  /** Issue due date */
  dueDate?: Maybe<Scalars['DateTime']>;
  /**
   * Issue cause
   *
   * Cause of the issue
   */
  issueCause?: Maybe<IssueCause>;
  /**
   * Issues in external system
   *
   * Issues specific data in external system
   */
  issueExternals: Array<IssueExternal>;
  /** Numerical identifier */
  issueID?: Maybe<Scalars['Int']>;
  /**
   * Issue status
   *
   * Current status of the issue
   */
  issueStatus?: Maybe<IssueStatus>;
  /**
   * Issue type
   *
   * Type of the issue
   */
  issueType?: Maybe<IssueType>;
  /**
   * Location description
   *
   * Text description of the issue location
   */
  locationDescription?: Maybe<Scalars['String']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Issue title */
  name?: Maybe<Scalars['String']>;
  /**
   * Owner
   *
   * User who owns the issue
   */
  owner?: Maybe<User>;
  /**
   * Related project
   *
   * Project where the issue is
   */
  project?: Maybe<Project>;
  /**
   * Related project file version
   *
   * File version where the issue is
   */
  projectFileVersion?: Maybe<ProjectFileVersion>;
  /**
   * Reporter
   *
   * User the issue was reported by
   */
  reporter?: Maybe<User>;
};


/** Bim 360 issue. */
export type IssueIssueExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

/** Type of cause of an issue. */
export type IssueCause = {
  /** Child cause */
  children: Array<IssueCause>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Cause description */
  description?: Maybe<Scalars['String']>;
  /**
   * Causes in external system
   *
   * Issues cause specific data in external system
   */
  issueCauseExternals: Array<IssueCauseExternal>;
  /** Issue cause ID */
  issueCauseID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Cause name */
  name?: Maybe<Scalars['String']>;
  /** Parent cause */
  parentCause?: Maybe<IssueCause>;
  /** Project */
  project?: Maybe<Project>;
};


/** Type of cause of an issue. */
export type IssueCauseChildrenArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Type of cause of an issue. */
export type IssueCauseIssueCauseExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type IssueCauseExternal = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Identifier in external system */
  externalID?: Maybe<Scalars['String']>;
  /** External system */
  externalSystem?: Maybe<ExternalSystem>;
  /** Related cause */
  issueCause?: Maybe<IssueCause>;
  issueCauseExternalID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
};

/** Issue in external system. */
export type IssueExternal = {
  /** Unique issue code */
  code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Identifier in external system */
  externalID?: Maybe<Scalars['String']>;
  /** External system */
  externalSystem?: Maybe<ExternalSystem>;
  /** Related issue */
  issue?: Maybe<Issue>;
  /** Issue in external system database ID. */
  issueExternalID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Position of the issue according to external system */
  position?: Maybe<Scalars['String']>;
};

export type IssueInExternalSystemInput = {
  /** External system code */
  externalSystemCode: Scalars['String'];
  /** Location */
  location?: Maybe<Scalars['String']>;
  /** Issue ID */
  issueID?: Maybe<Scalars['String']>;
  /** Issue type ID */
  issueTypeID?: Maybe<Scalars['String']>;
  /** Issue cause ID */
  issueCauseID?: Maybe<Scalars['String']>;
  /** Issue status ID */
  issueStatusID?: Maybe<Scalars['String']>;
  /** Starting version */
  versionFrom?: Maybe<Scalars['Int']>;
};

export type IssueInput = {
  /** Issue name */
  name: Scalars['String'];
  /** Issue decription */
  description?: Maybe<Scalars['String']>;
  /** Due date */
  dueDate?: Maybe<Scalars['DateTime']>;
  /** Text description of location of an issue */
  locationDescription?: Maybe<Scalars['String']>;
  /** Project ID */
  projectID?: Maybe<Scalars['Int']>;
  /** Project file version ID */
  projectFileVersionID?: Maybe<Scalars['Int']>;
  /** Issue status ID */
  issueStatusID?: Maybe<Scalars['Int']>;
  /** Issue type ID */
  issueTypeID?: Maybe<Scalars['Int']>;
  /** Issue cause ID */
  issueCauseID?: Maybe<Scalars['Int']>;
  /** Assigned to user ID */
  assignedToUserID?: Maybe<Scalars['Int']>;
  /** Reporter user ID */
  reporterUserID?: Maybe<Scalars['Int']>;
  /** Owner user ID */
  ownerUserID?: Maybe<Scalars['Int']>;
  externalSystemData: IssueInExternalSystemInput;
};

/** Status of an issue. */
export type IssueStatus = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Flag whether the state is allowed to be assigned during issue creation */
  creationEnabled?: Maybe<Scalars['Boolean']>;
  /** Default sorting order */
  defaultSortOrder?: Maybe<Scalars['Int']>;
  /** Status description */
  description?: Maybe<Scalars['String']>;
  /**
   * Highlight color
   *
   * Color used for some kinds of highlighting
   */
  highlightColor?: Maybe<Scalars['String']>;
  /**
   * Status in external system
   *
   * Issues Status specific data in external system
   */
  issueStatusExternals: Array<IssueStatusExternal>;
  /** Numerical identifier */
  issueStatusID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Status name */
  name?: Maybe<Scalars['String']>;
};


/** Status of an issue. */
export type IssueStatusIssueStatusExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type IssueStatusExternal = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Identifier in external system */
  externalID?: Maybe<Scalars['String']>;
  /** External system */
  externalSystem?: Maybe<ExternalSystem>;
  /** Related status */
  issueStatus?: Maybe<IssueStatus>;
  issueStatusExternalID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
};

/** Type of issue. */
export type IssueType = {
  /** Child types */
  children: Array<IssueType>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Type description */
  description?: Maybe<Scalars['String']>;
  /**
   * Types in external system
   *
   * Issues type specific data in external system
   */
  issueTypeExternals: Array<IssueTypeExternal>;
  /** Issue type ID */
  issueTypeID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Type name */
  name?: Maybe<Scalars['String']>;
  /** Parent type */
  parent?: Maybe<IssueType>;
  /** Project */
  project?: Maybe<Project>;
};


/** Type of issue. */
export type IssueTypeChildrenArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Type of issue. */
export type IssueTypeIssueTypeExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type IssueTypeExternal = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Identifier in external system */
  externalID?: Maybe<Scalars['String']>;
  /** External system */
  externalSystem?: Maybe<ExternalSystem>;
  issueTypeExternalID?: Maybe<Scalars['Int']>;
  /** Related type */
  issueTypes?: Maybe<IssueType>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
};

export type IssueUpdateInput = {
  /** Issue name */
  name?: Maybe<Scalars['String']>;
  /** Issue decription */
  description?: Maybe<Scalars['String']>;
  /** Due date */
  dueDate?: Maybe<Scalars['DateTime']>;
  /** Text description of location of an issue */
  locationDescription?: Maybe<Scalars['String']>;
  /** Project ID */
  projectID?: Maybe<Scalars['Int']>;
  /** Project file version ID */
  projectFileVersionID?: Maybe<Scalars['Int']>;
  /** Issue status ID */
  issueStatusID?: Maybe<Scalars['Int']>;
  /** Issue type ID */
  issueTypeID?: Maybe<Scalars['Int']>;
  /** Issue cause ID */
  issueCauseID?: Maybe<Scalars['Int']>;
  /** Assigned to user ID */
  assignedToUserID?: Maybe<Scalars['Int']>;
  /** Reporter user ID */
  reporterUserID?: Maybe<Scalars['Int']>;
  /** Owner user ID */
  ownerUserID?: Maybe<Scalars['Int']>;
  externalSystemData: IssueInExternalSystemInput;
};

export type KeyValuePairInput = {
  /** Key */
  key: Scalars['String'];
  /** Value */
  value: Scalars['String'];
};

/** Language. */
export type Language = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** ISO 6391 code. */
  iSO6391Code?: Maybe<Scalars['String']>;
  /** Identity, Required, Indexed. */
  languageID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Language name. */
  name?: Maybe<Scalars['String']>;
  /** Language native name. */
  nativeName?: Maybe<Scalars['String']>;
};


/** Element rule group. */
export type LookupRule = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Primary identifier. */
  elementLookupRuleID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
};

export type MappingFilter = {
  attribute?: Maybe<Scalars['String']>;
  condition?: Maybe<FilterCondition>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  mappingFilterGroup?: Maybe<MappingFilterGroup>;
  mappingFilterID?: Maybe<Scalars['Int']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  propertySet?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MappingFilterGroup = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  element?: Maybe<Element>;
  mappingFilterGroupID?: Maybe<Scalars['Int']>;
  mappingFilters: Array<MappingFilter>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
};


export type MappingFilterGroupMappingFiltersArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

/** Material definition. */
export type Material = {
  /** Identity - Descriptive / class. */
  class?: Maybe<Scalars['String']>;
  /** Identity - Descriptive / Comments. */
  comment?: Maybe<Scalars['String']>;
  /** Thermal - Properties / Compressibility. */
  compressibility?: Maybe<Scalars['Float']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Thermal - Properties / Electrical_Resistivity. */
  electricalResistivity?: Maybe<Scalars['Float']>;
  /** Thermal - Properties / Emissivity. */
  emissivity?: Maybe<Scalars['Float']>;
  /** Identity - Descriptive / Artikelnummer (G-TIN). */
  itemNumber?: Maybe<Scalars['String']>;
  /** Identity - Descriptive / Artikel-tag. */
  itemTag?: Maybe<Scalars['String']>;
  /** Identity - Product / URL. */
  link?: Maybe<Scalars['String']>;
  /** Identity - Descriptive / Li.-Preis. */
  liPrice?: Maybe<Scalars['Float']>;
  /** Identity - Product / Manufacturer. */
  manufacturer?: Maybe<Scalars['String']>;
  /** Material identifier. */
  materialID?: Maybe<Scalars['Int']>;
  /** Identity - Product / Model. */
  model?: Maybe<Scalars['String']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Thermal - Properties / Permeability. */
  permeability?: Maybe<Scalars['Float']>;
  /** Physical - Behavior / Behavior_Physical. */
  physicalBehavior?: Maybe<PhysicalBehavior>;
  /** Physical - Mechanical / Density_Physical. */
  physicalDensity?: Maybe<Scalars['Float']>;
  /** Physical - Information / Description_Physical. */
  physicalDescription?: Maybe<Scalars['String']>;
  /** Physical - Information / Source_Physical. */
  physicalSource?: Maybe<Scalars['String']>;
  /** Physical - Information / Source_URL_Physical. */
  physicalSourceLink?: Maybe<Scalars['String']>;
  /** Physical - Mechanical / Poissons_Ratio_X. */
  poissonsRatioX?: Maybe<Scalars['Float']>;
  /** Physical - Mechanical / Poissons_Ratio_Y. */
  poissonsRatioY?: Maybe<Scalars['Float']>;
  /** Physical - Mechanical / Poissons_Ratio_Z. */
  poissonsRatioZ?: Maybe<Scalars['Float']>;
  /** Thermal - Properties / Porosity. */
  porosity?: Maybe<Scalars['Float']>;
  /** Identity - Product / Cost. */
  price?: Maybe<Scalars['Float']>;
  /** Identity - Descriptive / Produkt_ID. */
  productID?: Maybe<Scalars['String']>;
  referenceUnit?: Maybe<AttributeType>;
  /** Thermal - Properties / Reflectivity. */
  reflectivity?: Maybe<Scalars['Float']>;
  /** Physical - Mechanical / Shear_Modulus_X. */
  shearModulusX?: Maybe<Scalars['Float']>;
  /** Physical - Mechanical / Shear_Modulus_Y. */
  shearModulusY?: Maybe<Scalars['Float']>;
  /** Physical - Mechanical / Shear_Modulus_Z. */
  shearModulusZ?: Maybe<Scalars['Float']>;
  /** Thermal - Properties / Specific_Heat. */
  specificHeat?: Maybe<Scalars['Float']>;
  /** Physical - Information / StructuralAssetClass. */
  structuralAssetClass?: Maybe<StructuralAssetClass>;
  /** Physical - Information / Subclass. */
  subclass?: Maybe<Scalars['String']>;
  /** Identity - Descriptive / Zuschlag - in percent. */
  surcharge?: Maybe<Scalars['Float']>;
  /** Physical - Strength / Tensile_Strength. */
  tensileStrength?: Maybe<Scalars['Float']>;
  /** Thermal - Properties / Thermal_Conductivity. */
  thermalConductivity?: Maybe<Scalars['Float']>;
  /** Physical - Thermal / Thermal_Expansion_Coeficient_X. */
  thermalExpansionCoefficientX?: Maybe<Scalars['Float']>;
  /** Physical - Thermal / Thermal_Expansion_Coeficient_Y. */
  thermalExpansionCoefficientY?: Maybe<Scalars['Float']>;
  /** Physical - Thermal / Thermal_Expansion_Coeficient_Z. */
  thermalExpansionCoefficientZ?: Maybe<Scalars['Float']>;
  /** Thermal - Information / ThermalMaterialType. */
  thermalMaterialType?: Maybe<ThermalMaterialType>;
  /** Thermal - Properties / Behavior_Thermical. */
  thermicalBehavior?: Maybe<ThermicalBehavior>;
  /** Thermal - Properties / Density_Thermical. */
  thermicalDensity?: Maybe<Scalars['Float']>;
  /** Thermal - Information / Description_Thermical. */
  thermicalDescription?: Maybe<Scalars['String']>;
  /** Thermal - Information / Source_Thermical. */
  thermicalSource?: Maybe<Scalars['String']>;
  /** Thermal - Information / Source_URL_Thermical. */
  thermicalSourceLink?: Maybe<Scalars['String']>;
  /** Thermal - Properties / Transmits_light. */
  transmitsLight?: Maybe<Scalars['Boolean']>;
  /** Physical - Strength / Yield_Strength. */
  yieldStrength?: Maybe<Scalars['Float']>;
  /** Physical - Mechanical / Youngs_Modulus_X. */
  youngsModulusX?: Maybe<Scalars['Float']>;
  /** Physical - Mechanical / Youngs_Modulus_Y. */
  youngsModulusY?: Maybe<Scalars['Float']>;
  /** Physical - Mechanical / Youngs_Modulus_Z. */
  youngsModulusZ?: Maybe<Scalars['Float']>;
};

/** Material type. */
export enum MaterialType {
  /** Material physisch. */
  PHYSICAL = 'PHYSICAL',
  /** Material zusätzlich. */
  ADDITIONAL = 'ADDITIONAL'
}


export type Mutation = {
  createIssue?: Maybe<Issue>;
  createIssueRemote?: Maybe<Issue>;
  updateIssueRemote?: Maybe<Issue>;
};


export type MutationCreateIssueArgs = {
  issue: IssueInput;
};


export type MutationCreateIssueRemoteArgs = {
  issue: IssueInput;
  externalSystemCode?: Maybe<Scalars['String']>;
  externalArguments?: Maybe<Array<Maybe<KeyValuePairInput>>>;
};


export type MutationUpdateIssueRemoteArgs = {
  issue: IssueUpdateInput;
  externalSystemCode?: Maybe<Scalars['String']>;
  externalArguments?: Maybe<Array<Maybe<KeyValuePairInput>>>;
};

export type OrderByGraph = {
  path: Scalars['String'];
  descending?: Maybe<Scalars['Boolean']>;
};

/** Physical behavior. */
export enum PhysicalBehavior {
  /** Isotropic. */
  ISOTROPIC = 'ISOTROPIC',
  /** Unknown. */
  UNKNOWN = 'UNKNOWN'
}

export type PriceSource = {
  code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  priceSourceID?: Maybe<Scalars['Int']>;
  priceType?: Maybe<PriceType>;
};

/** Type of price. */
export enum PriceType {
  /** Type of price specifiying total price for item. */
  TOTAL = 'TOTAL',
  /** Type of price specifying price for unit. */
  UNIT = 'UNIT'
}

/**
 * BIM Project
 *
 * Represents single BIM project (in eg. BIM 360)
 */
export type Project = {
  active?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  dataModel?: Maybe<DataModel>;
  description?: Maybe<Scalars['String']>;
  lastUpdate?: Maybe<Scalars['DateTime']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  notificationReceiver?: Maybe<Scalars['String']>;
  projectAttributes: Array<ProjectAttribute>;
  projectCategories: Array<ProjectCategory>;
  projectDashboards: Array<ProjectDashboard>;
  projectExternals: Array<ProjectExternal>;
  projectFile?: Maybe<ProjectFile>;
  projectFiles: Array<ProjectFile>;
  projectID?: Maybe<Scalars['Int']>;
  sensorModelStocks: Array<SensorModelStock>;
  status?: Maybe<Scalars['Int']>;
  /** Update type of the project. */
  updateType?: Maybe<UpdateType>;
  viewerViewpoint?: Maybe<ViewerViewpoint>;
  viewerViewpoints: Array<ViewerViewpoint>;
};


/**
 * BIM Project
 *
 * Represents single BIM project (in eg. BIM 360)
 */
export type ProjectProjectAttributesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/**
 * BIM Project
 *
 * Represents single BIM project (in eg. BIM 360)
 */
export type ProjectProjectCategoriesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/**
 * BIM Project
 *
 * Represents single BIM project (in eg. BIM 360)
 */
export type ProjectProjectDashboardsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/**
 * BIM Project
 *
 * Represents single BIM project (in eg. BIM 360)
 */
export type ProjectProjectExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/**
 * BIM Project
 *
 * Represents single BIM project (in eg. BIM 360)
 */
export type ProjectProjectFilesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/**
 * BIM Project
 *
 * Represents single BIM project (in eg. BIM 360)
 */
export type ProjectSensorModelStocksArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/**
 * BIM Project
 *
 * Represents single BIM project (in eg. BIM 360)
 */
export type ProjectViewerViewpointsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type ProjectAttribute = {
  attributeType?: Maybe<AttributeType>;
  code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  highlighColor?: Maybe<Scalars['String']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  parentProjectAttribute?: Maybe<ProjectAttribute>;
  project?: Maybe<Project>;
  projectAttributeGroup?: Maybe<ProjectAttributeGroup>;
  projectAttributeID?: Maybe<Scalars['Int']>;
  projectAttributes: Array<ProjectAttribute>;
  projectAttributeValues: Array<ProjectAttributeValue>;
  projectDashboardAttributes: Array<ProjectDashboardAttribute>;
  projectFile?: Maybe<ProjectFile>;
  value?: Maybe<Scalars['String']>;
  valueGetter?: Maybe<Scalars['String']>;
};


export type ProjectAttributeProjectAttributesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ProjectAttributeProjectAttributeValuesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ProjectAttributeProjectDashboardAttributesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type ProjectAttributeGroup = {
  code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  projectAttributeGroupID?: Maybe<Scalars['Int']>;
  projectAttributes: Array<ProjectAttribute>;
};


export type ProjectAttributeGroupProjectAttributesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type ProjectAttributeValue = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  projectAttribute?: Maybe<ProjectAttribute>;
  projectAttributeValueID?: Maybe<Scalars['Int']>;
  projectFile?: Maybe<ProjectFile>;
  projectFileVersion?: Maybe<ProjectFileVersion>;
  value?: Maybe<Scalars['String']>;
};

/** Mapping between project and Element Category. List of ProjectCategory entities make project specific catalogue. */
export type ProjectCategory = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  elementCategory?: Maybe<ElementCategory>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  project?: Maybe<Project>;
  /** Project category identifier. */
  projectCategoryID?: Maybe<Scalars['Int']>;
  /** Sorting order. */
  sortOrder?: Maybe<Scalars['Int']>;
};

export type ProjectDashboard = {
  attributes: Array<ProjectDashboardAttribute>;
  code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  dashboardType?: Maybe<DashboardType>;
  description?: Maybe<Scalars['String']>;
  includeLastUpdate?: Maybe<Scalars['Boolean']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
  projectDashboardID?: Maybe<Scalars['Int']>;
};


export type ProjectDashboardAttributesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type ProjectDashboardAttribute = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  projectAttribute?: Maybe<ProjectAttribute>;
  projectDashboard?: Maybe<ProjectDashboard>;
  projectDashboardAttributeID?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type ProjectExternal = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  externalID?: Maybe<Scalars['String']>;
  externalSystem?: Maybe<ExternalSystem>;
  /**
   * External System code
   *
   * External System code
   */
  externalSystemCode?: Maybe<Scalars['String']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  project?: Maybe<Project>;
  projectExternalID?: Maybe<Scalars['Int']>;
};

export type ProjectFile = {
  adapter?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<FileType>;
  /**
   * Last version
   *
   * Last version of the file
   */
  lastVersion?: Maybe<ProjectFileVersion>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  project?: Maybe<Project>;
  projectAttributes: Array<ProjectAttribute>;
  projectAttributeValues: Array<ProjectAttributeValue>;
  projectFileExternals: Array<ProjectFileExternal>;
  projectFileID?: Maybe<Scalars['Int']>;
  projectFileVersions: Array<ProjectFileVersion>;
  projects: Array<Project>;
  viewerViewpoint?: Maybe<ViewerViewpoint>;
};


export type ProjectFileProjectAttributesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ProjectFileProjectAttributeValuesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ProjectFileProjectFileExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ProjectFileProjectFileVersionsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ProjectFileProjectsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type ProjectFileExternal = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  externalFolder?: Maybe<Scalars['String']>;
  externalID?: Maybe<Scalars['String']>;
  externalSystem?: Maybe<ExternalSystem>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  projectFile?: Maybe<ProjectFile>;
  projectFileExternalID?: Maybe<Scalars['Int']>;
};

export type ProjectFileVersion = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  /**
   * Valid flag
   *
   * Simple representation of validity
   */
  isValid?: Maybe<Scalars['Boolean']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  projectAttributeValues: Array<ProjectAttributeValue>;
  projectFile?: Maybe<ProjectFile>;
  projectFileVersionExternals: Array<ProjectFileVersionExternal>;
  projectFileVersionID?: Maybe<Scalars['Int']>;
  projectFileVersionSensors: Array<ProjectFileVersionSensor>;
  projectFileVersionViewables: Array<ProjectFileVersionViewable>;
  sensorAssemblyGeometries: Array<SensorAssemblyGeometry>;
  /**
   * Valid from
   *
   * The begining of the valid period
   */
  validFrom?: Maybe<Scalars['DateTime']>;
  /**
   * Valid to
   *
   * The end of the valid period, null if no end of the valid period
   */
  validTo?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};


export type ProjectFileVersionProjectAttributeValuesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ProjectFileVersionProjectFileVersionExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ProjectFileVersionProjectFileVersionSensorsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ProjectFileVersionProjectFileVersionViewablesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ProjectFileVersionSensorAssemblyGeometriesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type ProjectFileVersionExternal = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  externalID?: Maybe<Scalars['String']>;
  externalSystem?: Maybe<ExternalSystem>;
  /**
   * External System code
   *
   * External System code
   */
  externalSystemCode?: Maybe<Scalars['String']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  projectFileVersion?: Maybe<ProjectFileVersion>;
  projectFileVersionExternalID?: Maybe<Scalars['Int']>;
};

export type ProjectFileVersionSensor = {
  displayGraph?: Maybe<Scalars['Boolean']>;
  displayName?: Maybe<Scalars['Boolean']>;
  projectFileVersion?: Maybe<ProjectFileVersion>;
  projectFileVersionSensorID?: Maybe<Scalars['Int']>;
  sensorGraphColors?: Maybe<SensorGraphColor>;
  sensorLocationExternals: Array<SensorLocationExternal>;
  sensorModelStock?: Maybe<SensorModelStock>;
};


export type ProjectFileVersionSensorSensorLocationExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type ProjectFileVersionViewable = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  instancesInViewable: Array<InstanceInViewable>;
  isValid?: Maybe<Scalars['Boolean']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  projectFileVersion?: Maybe<ProjectFileVersion>;
  projectFileVersionViewableExternals: Array<ProjectFileVersionViewableExternal>;
  projectFileVersionViewableID?: Maybe<Scalars['Int']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validTo?: Maybe<Scalars['DateTime']>;
  viewableType?: Maybe<Scalars['Int']>;
};


export type ProjectFileVersionViewableInstancesInViewableArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ProjectFileVersionViewableProjectFileVersionViewableExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type ProjectFileVersionViewableExternal = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  externalID?: Maybe<Scalars['String']>;
  externalSystem?: Maybe<ExternalSystem>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  projectFileVersionViewable?: Maybe<ProjectFileVersionViewable>;
  projectFileVersionViewableExternalID?: Maybe<Scalars['Int']>;
};

/** Represents instance by filter and project file version viewable */
export type ProjectFileVersionViewableInstances = {
  instances?: Maybe<Array<Maybe<Scalars['String']>>>;
  viewable?: Maybe<ProjectFileVersionViewable>;
};

/** Basic Queries */
export type Query = {
  /** Get list of AttributeMapping */
  attributeMappings: Array<AttributeMapping>;
  /** Get list of AttributeRole */
  attributeRoles: Array<AttributeRole>;
  /** Get list of AttributeType */
  attributeTypes: Array<AttributeType>;
  /** Get list of CategoryEquipment */
  categoryEquipment: Array<CategoryEquipment>;
  /** Get list of CategoryMaterial */
  categoryMaterial: Array<CategoryMaterial>;
  /** Get list of CategoryWork */
  categoryWork: Array<CategoryWork>;
  costsPerCategories?: Maybe<CostReport>;
  /** Get list of Currency */
  currencies: Array<Currency>;
  /** Get list of ProjectDashboardAttribute */
  dashboardAttributes: Array<ProjectDashboardAttribute>;
  /** Get list of DataModel */
  dataModels: Array<DataModel>;
  /** Get list of DerivedCategory */
  derivedCategories: Array<DerivedCategory>;
  /** Get list of ElementAttribute */
  elementAttributes: Array<ElementAttribute>;
  /** Get list of ElementAttributeValue */
  elementAttributeValues: Array<ElementAttributeValue>;
  /** Get list of ElementCategory */
  elementCategories: Array<ElementCategory>;
  /** Get list of LookupRule */
  elementLookupRules: Array<LookupRule>;
  /** Get list of ElementPrice */
  elementPrices: Array<ElementPrice>;
  /** Get list of Element */
  elements: Array<Element>;
  /** Get list of Equipment */
  equipment: Array<Equipment>;
  /** Get list of ExternalSystem */
  externalSystems: Array<ExternalSystem>;
  /** Get list of Family */
  families: Array<Family>;
  /** Get list of FamilyExternal */
  familyExternals: Array<FamilyExternal>;
  /** Get list of FileType */
  fileTypes: Array<FileType>;
  /** Get list of Graphics */
  graphics: Array<Graphics>;
  /** Get list of GraphicsPattern */
  graphicsPatterns: Array<GraphicsPattern>;
  /** Get list of IgnoredRevitCategory */
  ignoredRevitCategories: Array<IgnoredRevitCategory>;
  /** Get list of InstanceExternal */
  instanceExternals: Array<InstanceExternal>;
  /** Get list of InstanceInViewable */
  instanceInViewables: Array<InstanceInViewable>;
  /** Get list of InstanceRelation */
  instanceRelations: Array<InstanceRelation>;
  /** Get list of Instance */
  instances: Array<Instance>;
  /** Get list of IssueCause */
  issueCauses: Array<IssueCause>;
  /** Get list of IssueCauseExternal */
  issueCausesExternals: Array<IssueCauseExternal>;
  /** Get list of Issue */
  issues: Array<Issue>;
  /** Get list of IssueExternal */
  issuesExternals: Array<IssueExternal>;
  /** Get list of IssueStatus */
  issueStatuses: Array<IssueStatus>;
  /** Get list of IssueStatusExternal */
  issueStatusesExternals: Array<IssueStatusExternal>;
  /** Get list of IssueType */
  issueTypes: Array<IssueType>;
  /** Get list of IssueTypeExternal */
  issueTypesExternals: Array<IssueTypeExternal>;
  /** Get list of Language */
  languages: Array<Language>;
  /** Get list of MappingFilterGroup */
  mappingFilterGroups: Array<MappingFilterGroup>;
  /** Get list of MappingFilter */
  mappingFilters: Array<MappingFilter>;
  /** Get list of Material */
  materials: Array<Material>;
  /** Get list of PriceSource */
  priceSources: Array<PriceSource>;
  /** Get list of ProjectAttributeGroup */
  projectAttributeGroups: Array<ProjectAttributeGroup>;
  /** Get list of ProjectAttribute */
  projectAttributes: Array<ProjectAttribute>;
  /** Get list of ProjectAttributeValue */
  projectAttributeValues: Array<ProjectAttributeValue>;
  /** Get list of ProjectCategory */
  projectCategories: Array<ProjectCategory>;
  /** Get list of ProjectDashboard */
  projectDashboards: Array<ProjectDashboard>;
  /** Get list of ProjectExternal */
  projectExternals: Array<ProjectExternal>;
  /** Get list of ProjectFileExternal */
  projectFileExternals: Array<ProjectFileExternal>;
  /** Get list of ProjectFile */
  projectFiles: Array<ProjectFile>;
  /** Get list of ProjectFileVersionExternal */
  projectFileVersionExternals: Array<ProjectFileVersionExternal>;
  /** Get list of ProjectFileVersion */
  projectFileVersions: Array<ProjectFileVersion>;
  /** Get list of ProjectFileVersionSensor */
  projectFileVersionSensors: Array<ProjectFileVersionSensor>;
  /** Get list of ProjectFileVersionViewableExternal */
  projectFileVersionViewableExternals: Array<ProjectFileVersionViewableExternal>;
  /** Get list of ProjectFileVersionViewable */
  projectFileVersionViewables: Array<ProjectFileVersionViewable>;
  /** Get list of Project */
  projects: Array<Project>;
  /** Get list of RelationDefinition */
  relationDefinitions: Array<RelationDefinition>;
  /** Get list of RelationTree */
  relationTree: Array<RelationTree>;
  /** Get list of RelationTreeNodeSet */
  relationTreeNodeSet: Array<RelationTreeNodeSet>;
  /** Get list of RelationTreeRootNodeSet */
  relationTreeRootNodeSet: Array<RelationTreeRootNodeSet>;
  remoteIssueCauses?: Maybe<Array<Maybe<IssueCause>>>;
  remoteIssues?: Maybe<Array<Maybe<Issue>>>;
  remoteIssuesCount?: Maybe<Scalars['Int']>;
  remoteIssueStatuses?: Maybe<Array<Maybe<IssueStatus>>>;
  remoteIssueTypes?: Maybe<Array<Maybe<IssueType>>>;
  /** Get list of RevitCategory */
  revitCategories: Array<RevitCategory>;
  /** Get list of Role */
  roles: Array<Role>;
  /** Get list of SensorAssembly */
  sensorAssemblies: Array<SensorAssembly>;
  /** Get list of SensorAssemblyGeometry */
  sensorAssemblyGeometries: Array<SensorAssemblyGeometry>;
  /** Get list of SensorAssemblyGeometryExternal */
  sensorAssemblyGeometryExternals: Array<SensorAssemblyGeometryExternal>;
  /** Get list of SensorAssemblyItemExternal */
  sensorAssemblyItemExternals: Array<SensorAssemblyItemExternal>;
  /** Get list of SensorAssemblyItem */
  sensorAssemblyItems: Array<SensorAssemblyItem>;
  /** Get list of SensorGraphColor */
  sensorGraphColors: Array<SensorGraphColor>;
  /** Get list of SensorGraph */
  sensorGraphs: Array<SensorGraph>;
  /** Get list of SensorLocationExternal */
  sensorLocationExternals: Array<SensorLocationExternal>;
  /** Get list of SensorModel */
  sensorModels: Array<SensorModel>;
  /** Get list of SensorModelStock */
  sensorModelStocks: Array<SensorModelStock>;
  /** Get list of SensorType */
  sensorTypes: Array<SensorType>;
  /** Get list of SpecialModelInstance */
  specialModelInstances: Array<SpecialModelInstance>;
  syncedIssues?: Maybe<Array<Maybe<Issue>>>;
  /** Get list of TransformationMatrix */
  transformationMatrixes: Array<TransformationMatrix>;
  /** Get list of Translation */
  translations: Array<Translation>;
  /** Get list of TranslationTagMapping */
  translationTagMappings: Array<TranslationTagMapping>;
  /** Get list of TranslationTag */
  translationTags: Array<TranslationTag>;
  /** Get list of User */
  users: Array<User>;
  /** Get list of Vector */
  vectors: Array<Vector>;
  /** Get list of ViewerViewpoint */
  viewerViewpoints: Array<ViewerViewpoint>;
  /** Get list of Work */
  work: Array<Work>;
};


/** Basic Queries */
export type QueryAttributeMappingsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryAttributeRolesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryAttributeTypesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryCategoryEquipmentArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryCategoryMaterialArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryCategoryWorkArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryCostsPerCategoriesArgs = {
  projectFileVersionId?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryCurrenciesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryDashboardAttributesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryDataModelsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryDerivedCategoriesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryElementAttributesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryElementAttributeValuesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryElementCategoriesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryElementLookupRulesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryElementPricesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryElementsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryEquipmentArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryExternalSystemsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryFamiliesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryFamilyExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryFileTypesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryGraphicsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryGraphicsPatternsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryIgnoredRevitCategoriesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryInstanceExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryInstanceInViewablesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryInstanceRelationsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryInstancesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryIssueCausesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryIssueCausesExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryIssuesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryIssuesExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryIssueStatusesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryIssueStatusesExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryIssueTypesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryIssueTypesExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryLanguagesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryMappingFilterGroupsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryMappingFiltersArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryMaterialsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryPriceSourcesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectAttributeGroupsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectAttributesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectAttributeValuesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectCategoriesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectDashboardsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectFileExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectFilesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectFileVersionExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectFileVersionsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectFileVersionSensorsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectFileVersionViewableExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectFileVersionViewablesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryProjectsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryRelationDefinitionsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryRelationTreeArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryRelationTreeNodeSetArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryRelationTreeRootNodeSetArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryRemoteIssueCausesArgs = {
  externalSystemCode?: Maybe<Scalars['String']>;
  externalArguments?: Maybe<Array<Maybe<KeyValuePairInput>>>;
};


/** Basic Queries */
export type QueryRemoteIssuesArgs = {
  externalSystemCode?: Maybe<Scalars['String']>;
  externalArguments?: Maybe<Array<Maybe<KeyValuePairInput>>>;
};


/** Basic Queries */
export type QueryRemoteIssuesCountArgs = {
  externalSystemCode?: Maybe<Scalars['String']>;
  externalArguments?: Maybe<Array<Maybe<KeyValuePairInput>>>;
};


/** Basic Queries */
export type QueryRemoteIssueStatusesArgs = {
  externalSystemCode?: Maybe<Scalars['String']>;
  externalArguments?: Maybe<Array<Maybe<KeyValuePairInput>>>;
};


/** Basic Queries */
export type QueryRemoteIssueTypesArgs = {
  externalSystemCode?: Maybe<Scalars['String']>;
  externalArguments?: Maybe<Array<Maybe<KeyValuePairInput>>>;
};


/** Basic Queries */
export type QueryRevitCategoriesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryRolesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySensorAssembliesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySensorAssemblyGeometriesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySensorAssemblyGeometryExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySensorAssemblyItemExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySensorAssemblyItemsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySensorGraphColorsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySensorGraphsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySensorLocationExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySensorModelsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySensorModelStocksArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySensorTypesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySpecialModelInstancesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QuerySyncedIssuesArgs = {
  projectFileVersionId?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryTransformationMatrixesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryTranslationsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryTranslationTagMappingsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryTranslationTagsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryUsersArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryVectorsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryViewerViewpointsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Basic Queries */
export type QueryWorkArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type RelationDefinition = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  instance1Getter?: Maybe<Scalars['String']>;
  instance2Getter?: Maybe<Scalars['String']>;
  instanceRelations: Array<InstanceRelation>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  relationDefinitionID?: Maybe<Scalars['Int']>;
  type?: Maybe<RelationType>;
};


export type RelationDefinitionInstanceRelationsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type RelationTree = {
  code?: Maybe<Scalars['String']>;
  dataModel?: Maybe<DataModel>;
  name?: Maybe<Scalars['String']>;
  relationTreeID?: Maybe<Scalars['Int']>;
  relationTreeRootNodeSets: Array<RelationTreeRootNodeSet>;
};


export type RelationTreeRelationTreeRootNodeSetsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type RelationTreeNodeSet = {
  childNodeSets: Array<RelationTreeNodeSet>;
  parentNodeSet?: Maybe<RelationTreeNodeSet>;
  relationDefinition?: Maybe<RelationDefinition>;
  relationTreeNodeSetID?: Maybe<Scalars['Int']>;
};


export type RelationTreeNodeSetChildNodeSetsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type RelationTreeRootNodeSet = {
  relationTree?: Maybe<RelationTree>;
  relationTreeNodeSet?: Maybe<RelationTreeNodeSet>;
  relationTreeRootNodeSetID?: Maybe<Scalars['Int']>;
};

export enum RelationType {
  GEOMETRY_BASED = 'GEOMETRY_BASED',
  META_DATA_BASED = 'META_DATA_BASED'
}

/** Revit Category. */
export type RevitCategory = {
  /** Code. */
  code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Name Translation Key. */
  nameTranslationKey?: Maybe<Scalars['String']>;
  /** Revit Category identifier. */
  revitCategoryID?: Maybe<Scalars['Int']>;
  /** Revit ID - for Revit. */
  revitID?: Maybe<Scalars['Int']>;
};

export type Role = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  roleID?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};



export type SensorAssembly = {
  description?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sensorAssemblyGeometries: Array<SensorAssemblyGeometry>;
  sensorAssemblyID?: Maybe<Scalars['Int']>;
  sensorAssemblyItems: Array<SensorAssemblyItem>;
  sensorModels: Array<SensorModel>;
};


export type SensorAssemblySensorAssemblyGeometriesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type SensorAssemblySensorAssemblyItemsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type SensorAssemblySensorModelsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type SensorAssemblyGeometry = {
  projectFileVersions?: Maybe<ProjectFileVersion>;
  sensorAssemblies?: Maybe<SensorAssembly>;
  sensorAssemblyGeometryExternals: Array<SensorAssemblyGeometryExternal>;
  sensorAssemblyGeometryID?: Maybe<Scalars['Int']>;
};


export type SensorAssemblyGeometrySensorAssemblyGeometryExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type SensorAssemblyGeometryExternal = {
  externalSystem?: Maybe<ExternalSystem>;
  sensorAssemblyGeometry?: Maybe<SensorAssemblyGeometry>;
  sensorAssemblyGeometryExternalID?: Maybe<Scalars['Int']>;
  transformationMatrix?: Maybe<TransformationMatrix>;
};

export type SensorAssemblyItem = {
  sensorAssembly?: Maybe<SensorAssembly>;
  sensorAssemblyItemExternals: Array<SensorAssemblyItemExternal>;
  sensorAssemblyItemID?: Maybe<Scalars['Int']>;
  sensorModel?: Maybe<SensorModel>;
};


export type SensorAssemblyItemSensorAssemblyItemExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type SensorAssemblyItemExternal = {
  externalSystem?: Maybe<ExternalSystem>;
  sensorAssemblyItem?: Maybe<SensorAssemblyItem>;
  sensorAssemblyItemExternalID?: Maybe<Scalars['Int']>;
  transformationMatrix?: Maybe<TransformationMatrix>;
};

/** Sensor graph table. */
export type SensorGraph = {
  /** Meant for coord X or temperature. */
  doubleValue1?: Maybe<Scalars['Float']>;
  /** Meant for coord Y. */
  doubleValue2?: Maybe<Scalars['Float']>;
  /** Meant for coord Z. */
  doubleValue3?: Maybe<Scalars['Float']>;
  /** Graph point date (for grouping). */
  graphDate?: Maybe<Scalars['DateTime']>;
  /** Graph point time of day. */
  graphTime?: Maybe<Scalars['Seconds']>;
  /** Name of Mqqt channel. */
  mqqtCode?: Maybe<Scalars['String']>;
  /** Sensor graph ID. */
  sensorGraphID?: Maybe<Scalars['Int']>;
  /** Measured value of sensor device in string which can be number, coordinates or even json. */
  sourceValue?: Maybe<Scalars['String']>;
};

export type SensorGraphColor = {
  color?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  projectFileVersionSensors: Array<ProjectFileVersionSensor>;
  sensorGraphColorID?: Maybe<Scalars['Int']>;
};


export type SensorGraphColorProjectFileVersionSensorsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type SensorLocationExternal = {
  externalSystem?: Maybe<ExternalSystem>;
  projectFileVersionSensor?: Maybe<ProjectFileVersionSensor>;
  sensorLocationExternalID?: Maybe<Scalars['Int']>;
  vector?: Maybe<Vector>;
};

export type SensorModel = {
  description?: Maybe<Scalars['String']>;
  isLocalizationSensor?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Price of the sensor. */
  price?: Maybe<Scalars['Float']>;
  sensorAssembly?: Maybe<SensorAssembly>;
  sensorAssemblyItems: Array<SensorAssemblyItem>;
  sensorModelID?: Maybe<Scalars['Int']>;
  sensorModelStocks: Array<SensorModelStock>;
  sensorType?: Maybe<SensorType>;
  thumbnailImage?: Maybe<Scalars['String']>;
};


export type SensorModelSensorAssemblyItemsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type SensorModelSensorModelStocksArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type SensorModelStock = {
  inventaryCode?: Maybe<Scalars['String']>;
  mqqtCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
  projectFileVersionSensors: Array<ProjectFileVersionSensor>;
  sensorModel?: Maybe<SensorModel>;
  sensorModelStockID?: Maybe<Scalars['Int']>;
};


export type SensorModelStockProjectFileVersionSensorsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type SensorType = {
  description?: Maybe<Scalars['String']>;
  displayFormat?: Maybe<Scalars['String']>;
  isAssembly?: Maybe<Scalars['Boolean']>;
  measureUnits?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sensorModels: Array<SensorModel>;
  sensorTypeID?: Maybe<Scalars['Int']>;
};


export type SensorTypeSensorModelsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


/** Special instance in datamodel which may not belong to any know element, or has some specific meaning. */
export type SpecialModelInstance = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  dataModel?: Maybe<DataModel>;
  instance?: Maybe<Instance>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Special model instance identifier. */
  specialModelInstanceID?: Maybe<Scalars['Int']>;
  /** Special model instance type. */
  type?: Maybe<SpecialModelInstanceType>;
};

/** Additional model instance type. */
export enum SpecialModelInstanceType {
  /** Contains unknown attribute. */
  CONTAINS_UNKNOWN_ATTRIBUTE = 'CONTAINS_UNKNOWN_ATTRIBUTE',
  /** Uncategorized. */
  UNCATEGORIZED = 'UNCATEGORIZED'
}

export enum StringComparison {
  CURRENT_CULTURE = 'CURRENT_CULTURE',
  CURRENT_CULTURE_IGNORE_CASE = 'CURRENT_CULTURE_IGNORE_CASE',
  INVARIANT_CULTURE = 'INVARIANT_CULTURE',
  INVARIANT_CULTURE_IGNORE_CASE = 'INVARIANT_CULTURE_IGNORE_CASE',
  ORDINAL = 'ORDINAL',
  ORDINAL_IGNORE_CASE = 'ORDINAL_IGNORE_CASE'
}

/** Structural Asset Class. */
export enum StructuralAssetClass {
  /** Mauerwerk. */
  MAUERWERK = 'MAUERWERK',
  /** Generic. */
  GENERIC = 'GENERIC',
  /** Unknown. */
  UNKNOWN = 'UNKNOWN'
}

/** Thermal material type. */
export enum ThermalMaterialType {
  /** Solid. */
  SOLID = 'SOLID',
  /** Unknown. */
  UNKNOWN = 'UNKNOWN'
}

/** Thermical behavior. */
export enum ThermicalBehavior {
  /** Isotropic. */
  ISOTROPIC = 'ISOTROPIC',
  /** Unknown. */
  UNKNOWN = 'UNKNOWN'
}

export type TransformationMatrix = {
  matrix?: Maybe<Scalars['String']>;
  sensorAssemblyGeometryExternals: Array<SensorAssemblyGeometryExternal>;
  sensorAssemblyItemExternals: Array<SensorAssemblyItemExternal>;
  transformationMatrixID?: Maybe<Scalars['Int']>;
};


export type TransformationMatrixSensorAssemblyGeometryExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type TransformationMatrixSensorAssemblyItemExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

/** Translation. */
export type Translation = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Fallback translation. */
  fallbackText?: Maybe<Scalars['String']>;
  /** Is paragraph / page translation (longer than 150 chars.). */
  isLong?: Maybe<Scalars['Boolean']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Identity. */
  translationID?: Maybe<Scalars['Long']>;
  /** Translation key. */
  translationKey?: Maybe<Scalars['String']>;
  /** Long DE translation (more than 150 chars). */
  translationLongDE?: Maybe<Scalars['String']>;
  /** Long EN translation (more than 150 chars). */
  translationLongEN?: Maybe<Scalars['String']>;
  /** Long FR translation (more than 150 chars). */
  translationLongFR?: Maybe<Scalars['String']>;
  /** Long IT translation (more than 150 chars). */
  translationLongIT?: Maybe<Scalars['String']>;
  /** Short DE translation (max 150 chars). */
  translationShortDE?: Maybe<Scalars['String']>;
  /** Short EN translation (max 150 chars). */
  translationShortEN?: Maybe<Scalars['String']>;
  /** Short FR translation (max 150 chars). */
  translationShortFR?: Maybe<Scalars['String']>;
  /** Short IT translation (max 150 chars). */
  translationShortIT?: Maybe<Scalars['String']>;
  translationTagMapping: Array<TranslationTagMapping>;
};


/** Translation. */
export type TranslationTranslationTagMappingArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

/** Translation tag for reusing translations and grouping them into separate sets. */
export type TranslationTag = {
  /** Translation tag code. */
  code?: Maybe<Scalars['String']>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Description. */
  description?: Maybe<Scalars['String']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Translation tag name. */
  name?: Maybe<Scalars['String']>;
  /** Identity. */
  translationTagID?: Maybe<Scalars['Long']>;
  translationTagMapping: Array<TranslationTagMapping>;
};


/** Translation tag for reusing translations and grouping them into separate sets. */
export type TranslationTagTranslationTagMappingArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

/** Mapping between translation and translation tag. */
export type TranslationTagMapping = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  translation?: Maybe<Translation>;
  translationTag?: Maybe<TranslationTag>;
  /** Identity. */
  translationTagMappingID?: Maybe<Scalars['Long']>;
};




/** Update type. */
export enum UpdateType {
  /** On demand updates. */
  ON_DEMAND = 'ON_DEMAND',
  /** Automatic updates. */
  AUTOMATIC = 'AUTOMATIC'
}


export type User = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** E-mail */
  email?: Maybe<Scalars['String']>;
  /** First name */
  firstName?: Maybe<Scalars['String']>;
  /** First name */
  lastName?: Maybe<Scalars['String']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  roles: Array<Role>;
  /** User ID */
  userID?: Maybe<Scalars['Int']>;
  /** User name */
  userName?: Maybe<Scalars['String']>;
};


export type UserRolesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type Vector = {
  cameraViewerViewpoints: Array<ViewerViewpoint>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  directionViewerViewpoints: Array<ViewerViewpoint>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  positionViewerViewpoints: Array<ViewerViewpoint>;
  sensorLocationExternals: Array<SensorLocationExternal>;
  vectorID?: Maybe<Scalars['Int']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
};


export type VectorCameraViewerViewpointsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type VectorDirectionViewerViewpointsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type VectorPositionViewerViewpointsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type VectorSensorLocationExternalsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type ViewerViewpoint = {
  cameraVector?: Maybe<Vector>;
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  directionVector?: Maybe<Vector>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  positionVector?: Maybe<Vector>;
  project?: Maybe<Project>;
  projectFiles: Array<ProjectFile>;
  projects: Array<Project>;
  viewerViewpointID?: Maybe<Scalars['Int']>;
};


export type ViewerViewpointProjectFilesArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};


export type ViewerViewpointProjectsArgs = {
  id?: Maybe<Scalars['ID']>;
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderBy?: Maybe<Array<Maybe<OrderByGraph>>>;
  where?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type WhereExpressionGraph = {
  path?: Maybe<Scalars['String']>;
  comparison?: Maybe<ComparisonGraph>;
  negate?: Maybe<Scalars['Boolean']>;
  case?: Maybe<StringComparison>;
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
  connector?: Maybe<Connector>;
  groupedExpressions?: Maybe<Array<Maybe<WhereExpressionGraph>>>;
};

/** Work definition. */
export type Work = {
  /**
   * Created by
   *
   * ID of the user, who created this entity
   */
  createdBy?: Maybe<Scalars['Int']>;
  /**
   * Creation timestamp
   *
   * Date and time when the entity was created
   */
  createdDate?: Maybe<Scalars['DateTime']>;
  /** Artikel Nr. o. G TIN. */
  itemNumber?: Maybe<Scalars['String']>;
  /** Listen Preis - List price. */
  liPrice?: Maybe<Scalars['Float']>;
  /**
   * Last modification user
   *
   * ID of the user, who has done the last modification of this entity
   */
  modifiedBy?: Maybe<Scalars['Int']>;
  /**
   * Last modification timestamp
   *
   * Date and time when the entity was lastly modified
   */
  modifiedDate?: Maybe<Scalars['DateTime']>;
  /** Produkt ID. */
  productID?: Maybe<Scalars['String']>;
  /** Produkt Name. */
  productName?: Maybe<Scalars['String']>;
  /** Zuschlag in percent. */
  surcharge?: Maybe<Scalars['Float']>;
  /** Work identifier. */
  workID?: Maybe<Scalars['Int']>;
};

export type CreateIssueRemoteMutationVariables = Exact<{
  issue: IssueInput;
  externalArguments?: Maybe<Array<Maybe<KeyValuePairInput>>>;
}>;


export type CreateIssueRemoteMutation = { createIssueRemote?: Maybe<{ name?: Maybe<string>, issueID?: Maybe<number>, issueStatus?: Maybe<{ name?: Maybe<string> }>, issueExternals: Array<{ externalID?: Maybe<string>, externalSystem?: Maybe<{ code?: Maybe<string> }> }>, issueType?: Maybe<{ name?: Maybe<string>, parent?: Maybe<{ name?: Maybe<string> }> }> }> };

export type UpdateIssueRemoteMutationVariables = Exact<{
  issue: IssueUpdateInput;
  externalArguments?: Maybe<Array<Maybe<KeyValuePairInput>>>;
}>;


export type UpdateIssueRemoteMutation = { updateIssueRemote?: Maybe<{ name?: Maybe<string>, issueID?: Maybe<number>, issueStatus?: Maybe<{ name?: Maybe<string> }>, issueType?: Maybe<{ name?: Maybe<string>, parent?: Maybe<{ name?: Maybe<string> }> }> }> };

export type GetFormConfigQueryVariables = Exact<{
  accountUrn: Scalars['String'];
  projectUrn: Scalars['String'];
}>;


export type GetFormConfigQuery = { causes?: Maybe<Array<Maybe<(
    { children: Array<CauseFieldsFragment> }
    & CauseFieldsFragment
  )>>>, types?: Maybe<Array<Maybe<(
    { children: Array<TypeFieldsFragment> }
    & TypeFieldsFragment
  )>>>, statuses?: Maybe<Array<Maybe<{ issueStatusID?: Maybe<number>, name?: Maybe<string>, description?: Maybe<string>, highlightColor?: Maybe<string>, creationEnabled?: Maybe<boolean>, defaultSortOrder?: Maybe<number>, issueStatusExternals: Array<{ externalID?: Maybe<string>, externalSystem?: Maybe<{ code?: Maybe<string> }> }> }>>>, users: Array<{ userID?: Maybe<number> }> };

export type TypeFieldsFragment = { issueTypeID?: Maybe<number>, name?: Maybe<string>, description?: Maybe<string>, issueTypeExternals: Array<{ externalID?: Maybe<string>, externalSystem?: Maybe<{ code?: Maybe<string> }> }> };

export type CauseFieldsFragment = { issueCauseID?: Maybe<number>, name?: Maybe<string>, description?: Maybe<string>, issueCauseExternals: Array<{ externalID?: Maybe<string>, externalSystem?: Maybe<{ code?: Maybe<string> }> }> };

export type GetIssuesRemoteQueryVariables = Exact<{
  accountUrn: Scalars['String'];
  projectUrn: Scalars['String'];
  fileUrn: Scalars['String'];
  fromVersion: Scalars['String'];
  viewableGuid: Scalars['String'];
}>;


export type GetIssuesRemoteQuery = { issues?: Maybe<Array<Maybe<{ issueID?: Maybe<number>, name?: Maybe<string>, code?: Maybe<string>, description?: Maybe<string>, dueDate?: Maybe<any>, locationDescription?: Maybe<string>, issueCause?: Maybe<{ issueCauseID?: Maybe<number>, name?: Maybe<string>, issueCauseExternals: Array<{ externalID?: Maybe<string>, externalSystem?: Maybe<{ code?: Maybe<string> }> }> }>, issueExternals: Array<{ position?: Maybe<string>, externalID?: Maybe<string>, externalSystem?: Maybe<{ code?: Maybe<string> }> }>, issueStatus?: Maybe<{ issueStatusID?: Maybe<number>, name?: Maybe<string>, highlightColor?: Maybe<string>, issueStatusExternals: Array<{ externalID?: Maybe<string>, externalSystem?: Maybe<{ code?: Maybe<string> }> }> }>, issueType?: Maybe<{ issueTypeID?: Maybe<number>, name?: Maybe<string>, issueTypeExternals: Array<{ externalID?: Maybe<string>, externalSystem?: Maybe<{ code?: Maybe<string> }> }>, parent?: Maybe<{ issueTypeID?: Maybe<number>, name?: Maybe<string>, issueTypeExternals: Array<{ externalID?: Maybe<string>, externalSystem?: Maybe<{ code?: Maybe<string> }> }> }> }>, allowedStatuses?: Maybe<Array<{ issueStatusID?: Maybe<number>, name?: Maybe<string>, highlightColor?: Maybe<string>, issueStatusExternals: Array<{ externalID?: Maybe<string> }> }>> }>>> };

export type GetIssuesRemoteCountQueryVariables = Exact<{
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  fileId: Scalars['String'];
}>;


export type GetIssuesRemoteCountQuery = { count?: Maybe<number> };

export type GetSensorGraphDefaultColorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSensorGraphDefaultColorQuery = { sensorGraphColors: Array<{ sensorGraphColorID?: Maybe<number>, name?: Maybe<string>, color?: Maybe<string>, isDefault?: Maybe<boolean> }> };

export type GetSensorGraphColorByIdQueryVariables = Exact<{
  colorId?: Maybe<Scalars['String']>;
}>;


export type GetSensorGraphColorByIdQuery = { sensorGraphColors: Array<{ sensorGraphColorID?: Maybe<number>, name?: Maybe<string>, color?: Maybe<string>, isDefault?: Maybe<boolean> }> };

export type CostsPerCategoriesQueryVariables = Exact<{
  projectFileVersionId?: Maybe<Scalars['Int']>;
}>;


export type CostsPerCategoriesQuery = { costsPerCategories?: Maybe<{ totalAmount?: Maybe<number>, priceAttributeType?: Maybe<{ unit?: Maybe<string>, dataType?: Maybe<DataType> }>, categories?: Maybe<Array<Maybe<(
      { children?: Maybe<Array<Maybe<(
        { children?: Maybe<Array<Maybe<(
          { children?: Maybe<Array<Maybe<(
            { children?: Maybe<Array<Maybe<(
              { children?: Maybe<Array<Maybe<CostsValueFragment>>> }
              & CostsValueFragment
            )>>> }
            & CostsValueFragment
          )>>> }
          & CostsValueFragment
        )>>> }
        & CostsValueFragment
      )>>> }
      & CostsValueFragment
    )>>> }> };

export type CostsValueFragment = { geab?: Maybe<string>, source?: Maybe<string>, quantity?: Maybe<number>, unitPrice?: Maybe<number>, workNo?: Maybe<string>, price?: Maybe<number>, extraCharge?: Maybe<number>, totalPrice?: Maybe<number>, elementCategory?: Maybe<{ elementCategoryID?: Maybe<number>, code?: Maybe<string>, name?: Maybe<string>, description?: Maybe<string>, type?: Maybe<ElementCategoryType> }>, attributeType?: Maybe<{ unit?: Maybe<string>, dataType?: Maybe<DataType> }>, instancesPerFileVersionViewable?: Maybe<Array<Maybe<{ instances?: Maybe<Array<Maybe<string>>>, viewable?: Maybe<{ projectFileVersionViewableID?: Maybe<number>, viewableType?: Maybe<number>, name?: Maybe<string> }> }>>> };

export type GetProjectQueryVariables = Exact<{
  code?: Maybe<Scalars['String']>;
}>;


export type GetProjectQuery = { projects: Array<{ projectID?: Maybe<number>, name?: Maybe<string>, code?: Maybe<string>, dataModel?: Maybe<{ dataModelID?: Maybe<number> }>, projectExternals: Array<{ externalID?: Maybe<string>, externalSystem?: Maybe<{ code?: Maybe<string> }> }>, projectFiles: Array<{ projectFileID?: Maybe<number>, name?: Maybe<string>, fileName?: Maybe<string>, fileType?: Maybe<{ code?: Maybe<string> }>, projectFileVersions: Array<{ projectFileVersionID?: Maybe<number>, version?: Maybe<number>, projectFileVersionExternals: Array<{ externalID?: Maybe<string>, externalSystem?: Maybe<{ code?: Maybe<string> }> }>, projectFileVersionViewables: Array<{ projectFileVersionViewableID?: Maybe<number>, name?: Maybe<string>, viewableType?: Maybe<number>, projectFileVersionViewableExternals: Array<{ externalID?: Maybe<string>, externalSystem?: Maybe<{ code?: Maybe<string> }> }> }> }> }> }> };

export const TypeFieldsFragmentDoc = gql`
    fragment typeFields on IssueType {
  issueTypeID
  name
  description
  issueTypeExternals {
    externalID
    externalSystem {
      code
    }
  }
}
    `;
export const CauseFieldsFragmentDoc = gql`
    fragment causeFields on IssueCause {
  issueCauseID
  name
  description
  issueCauseExternals {
    externalID
    externalSystem {
      code
    }
  }
}
    `;
export const CostsValueFragmentDoc = gql`
    fragment CostsValue on CategoryReport {
  elementCategory {
    elementCategoryID
    code
    name
    description
    type
  }
  geab
  source
  quantity
  attributeType {
    unit
    dataType
  }
  unitPrice
  workNo
  price
  extraCharge
  totalPrice
  instancesPerFileVersionViewable {
    viewable {
      projectFileVersionViewableID
      viewableType
      name
    }
    instances
  }
}
    `;
export const CreateIssueRemoteDocument = gql`
    mutation CreateIssueRemote($issue: IssueInput!, $externalArguments: [KeyValuePairInput]) {
  createIssueRemote(
    issue: $issue
    externalSystemCode: "forge"
    externalArguments: $externalArguments
  ) {
    name
    issueID
    issueStatus {
      name
    }
    issueExternals {
      externalID
      externalSystem {
        code
      }
    }
    issueType {
      name
      parent {
        name
      }
    }
  }
}
    `;
export type CreateIssueRemoteMutationFn = Apollo.MutationFunction<CreateIssueRemoteMutation, CreateIssueRemoteMutationVariables>;

/**
 * __useCreateIssueRemoteMutation__
 *
 * To run a mutation, you first call `useCreateIssueRemoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIssueRemoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIssueRemoteMutation, { data, loading, error }] = useCreateIssueRemoteMutation({
 *   variables: {
 *      issue: // value for 'issue'
 *      externalArguments: // value for 'externalArguments'
 *   },
 * });
 */
export function useCreateIssueRemoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateIssueRemoteMutation, CreateIssueRemoteMutationVariables>) {
        return Apollo.useMutation<CreateIssueRemoteMutation, CreateIssueRemoteMutationVariables>(CreateIssueRemoteDocument, baseOptions);
      }
export type CreateIssueRemoteMutationHookResult = ReturnType<typeof useCreateIssueRemoteMutation>;
export type CreateIssueRemoteMutationResult = Apollo.MutationResult<CreateIssueRemoteMutation>;
export type CreateIssueRemoteMutationOptions = Apollo.BaseMutationOptions<CreateIssueRemoteMutation, CreateIssueRemoteMutationVariables>;
export const UpdateIssueRemoteDocument = gql`
    mutation UpdateIssueRemote($issue: IssueUpdateInput!, $externalArguments: [KeyValuePairInput]) {
  updateIssueRemote(
    issue: $issue
    externalSystemCode: "forge"
    externalArguments: $externalArguments
  ) {
    name
    issueID
    issueStatus {
      name
    }
    issueType {
      name
      parent {
        name
      }
    }
  }
}
    `;
export type UpdateIssueRemoteMutationFn = Apollo.MutationFunction<UpdateIssueRemoteMutation, UpdateIssueRemoteMutationVariables>;

/**
 * __useUpdateIssueRemoteMutation__
 *
 * To run a mutation, you first call `useUpdateIssueRemoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIssueRemoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIssueRemoteMutation, { data, loading, error }] = useUpdateIssueRemoteMutation({
 *   variables: {
 *      issue: // value for 'issue'
 *      externalArguments: // value for 'externalArguments'
 *   },
 * });
 */
export function useUpdateIssueRemoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIssueRemoteMutation, UpdateIssueRemoteMutationVariables>) {
        return Apollo.useMutation<UpdateIssueRemoteMutation, UpdateIssueRemoteMutationVariables>(UpdateIssueRemoteDocument, baseOptions);
      }
export type UpdateIssueRemoteMutationHookResult = ReturnType<typeof useUpdateIssueRemoteMutation>;
export type UpdateIssueRemoteMutationResult = Apollo.MutationResult<UpdateIssueRemoteMutation>;
export type UpdateIssueRemoteMutationOptions = Apollo.BaseMutationOptions<UpdateIssueRemoteMutation, UpdateIssueRemoteMutationVariables>;
export const GetFormConfigDocument = gql`
    query getFormConfig($accountUrn: String!, $projectUrn: String!) {
  causes: remoteIssueCauses(
    externalSystemCode: "forge"
    externalArguments: [{key: "accountId", value: $accountUrn}, {key: "projectId", value: $projectUrn}]
  ) {
    ...causeFields
    children {
      ...causeFields
    }
  }
  types: remoteIssueTypes(
    externalSystemCode: "forge"
    externalArguments: [{key: "accountId", value: $accountUrn}, {key: "projectId", value: $projectUrn}]
  ) {
    ...typeFields
    children {
      ...typeFields
    }
  }
  statuses: remoteIssueStatuses(
    externalSystemCode: "forge"
    externalArguments: [{key: "accountId", value: $accountUrn}, {key: "projectId", value: $projectUrn}]
  ) {
    issueStatusID
    name
    description
    highlightColor
    creationEnabled
    defaultSortOrder
    issueStatusExternals {
      externalID
      externalSystem {
        code
      }
    }
  }
  users: users {
    userID
  }
}
    ${CauseFieldsFragmentDoc}
${TypeFieldsFragmentDoc}`;

/**
 * __useGetFormConfigQuery__
 *
 * To run a query within a React component, call `useGetFormConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormConfigQuery({
 *   variables: {
 *      accountUrn: // value for 'accountUrn'
 *      projectUrn: // value for 'projectUrn'
 *   },
 * });
 */
export function useGetFormConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetFormConfigQuery, GetFormConfigQueryVariables>) {
        return Apollo.useQuery<GetFormConfigQuery, GetFormConfigQueryVariables>(GetFormConfigDocument, baseOptions);
      }
export function useGetFormConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormConfigQuery, GetFormConfigQueryVariables>) {
          return Apollo.useLazyQuery<GetFormConfigQuery, GetFormConfigQueryVariables>(GetFormConfigDocument, baseOptions);
        }
export type GetFormConfigQueryHookResult = ReturnType<typeof useGetFormConfigQuery>;
export type GetFormConfigLazyQueryHookResult = ReturnType<typeof useGetFormConfigLazyQuery>;
export type GetFormConfigQueryResult = Apollo.QueryResult<GetFormConfigQuery, GetFormConfigQueryVariables>;
export const GetIssuesRemoteDocument = gql`
    query GetIssuesRemote($accountUrn: String!, $projectUrn: String!, $fileUrn: String!, $fromVersion: String!, $viewableGuid: String!) {
  issues: remoteIssues(
    externalSystemCode: "forge"
    externalArguments: [{key: "accountId", value: $accountUrn}, {key: "projectId", value: $projectUrn}, {key: "fileId", value: $fileUrn}, {key: "fromVersion", value: $fromVersion}, {key: "viewableGuid", value: $viewableGuid}]
  ) {
    issueID
    name
    code
    issueCause {
      issueCauseID
      name
      issueCauseExternals(
        where: {path: "externalSystem.code", comparison: equal, value: "forge"}
      ) {
        externalID
        externalSystem {
          code
        }
      }
    }
    description
    dueDate
    issueExternals(
      where: {path: "externalSystem.code", comparison: equal, value: "forge"}
    ) {
      position
      externalID
      externalSystem {
        code
      }
    }
    locationDescription
    issueStatus {
      issueStatusID
      name
      highlightColor
      issueStatusExternals(
        where: {path: "externalSystem.code", comparison: equal, value: "forge"}
      ) {
        externalID
        externalSystem {
          code
        }
      }
    }
    issueType {
      issueTypeID
      name
      issueTypeExternals(
        where: {path: "externalSystem.code", comparison: equal, value: "forge"}
      ) {
        externalID
        externalSystem {
          code
        }
      }
      parent {
        issueTypeID
        name
        issueTypeExternals(
          where: {path: "externalSystem.code", comparison: equal, value: "forge"}
        ) {
          externalID
          externalSystem {
            code
          }
        }
      }
    }
    allowedStatuses {
      issueStatusID
      name
      highlightColor
      issueStatusExternals {
        externalID
      }
    }
  }
}
    `;

/**
 * __useGetIssuesRemoteQuery__
 *
 * To run a query within a React component, call `useGetIssuesRemoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssuesRemoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssuesRemoteQuery({
 *   variables: {
 *      accountUrn: // value for 'accountUrn'
 *      projectUrn: // value for 'projectUrn'
 *      fileUrn: // value for 'fileUrn'
 *      fromVersion: // value for 'fromVersion'
 *      viewableGuid: // value for 'viewableGuid'
 *   },
 * });
 */
export function useGetIssuesRemoteQuery(baseOptions?: Apollo.QueryHookOptions<GetIssuesRemoteQuery, GetIssuesRemoteQueryVariables>) {
        return Apollo.useQuery<GetIssuesRemoteQuery, GetIssuesRemoteQueryVariables>(GetIssuesRemoteDocument, baseOptions);
      }
export function useGetIssuesRemoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIssuesRemoteQuery, GetIssuesRemoteQueryVariables>) {
          return Apollo.useLazyQuery<GetIssuesRemoteQuery, GetIssuesRemoteQueryVariables>(GetIssuesRemoteDocument, baseOptions);
        }
export type GetIssuesRemoteQueryHookResult = ReturnType<typeof useGetIssuesRemoteQuery>;
export type GetIssuesRemoteLazyQueryHookResult = ReturnType<typeof useGetIssuesRemoteLazyQuery>;
export type GetIssuesRemoteQueryResult = Apollo.QueryResult<GetIssuesRemoteQuery, GetIssuesRemoteQueryVariables>;
export const GetIssuesRemoteCountDocument = gql`
    query GetIssuesRemoteCount($accountId: String!, $projectId: String!, $fileId: String!) {
  count: remoteIssuesCount(
    externalSystemCode: "forge"
    externalArguments: [{key: "accountId", value: $accountId}, {key: "projectId", value: $projectId}, {key: "fileId", value: $fileId}]
  )
}
    `;

/**
 * __useGetIssuesRemoteCountQuery__
 *
 * To run a query within a React component, call `useGetIssuesRemoteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssuesRemoteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssuesRemoteCountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      projectId: // value for 'projectId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetIssuesRemoteCountQuery(baseOptions?: Apollo.QueryHookOptions<GetIssuesRemoteCountQuery, GetIssuesRemoteCountQueryVariables>) {
        return Apollo.useQuery<GetIssuesRemoteCountQuery, GetIssuesRemoteCountQueryVariables>(GetIssuesRemoteCountDocument, baseOptions);
      }
export function useGetIssuesRemoteCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIssuesRemoteCountQuery, GetIssuesRemoteCountQueryVariables>) {
          return Apollo.useLazyQuery<GetIssuesRemoteCountQuery, GetIssuesRemoteCountQueryVariables>(GetIssuesRemoteCountDocument, baseOptions);
        }
export type GetIssuesRemoteCountQueryHookResult = ReturnType<typeof useGetIssuesRemoteCountQuery>;
export type GetIssuesRemoteCountLazyQueryHookResult = ReturnType<typeof useGetIssuesRemoteCountLazyQuery>;
export type GetIssuesRemoteCountQueryResult = Apollo.QueryResult<GetIssuesRemoteCountQuery, GetIssuesRemoteCountQueryVariables>;
export const GetSensorGraphDefaultColorDocument = gql`
    query getSensorGraphDefaultColor {
  sensorGraphColors(
    where: {path: "isDefault", comparison: equal, value: ["true"]}
  ) {
    sensorGraphColorID
    name
    color
    isDefault
  }
}
    `;

/**
 * __useGetSensorGraphDefaultColorQuery__
 *
 * To run a query within a React component, call `useGetSensorGraphDefaultColorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSensorGraphDefaultColorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSensorGraphDefaultColorQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSensorGraphDefaultColorQuery(baseOptions?: Apollo.QueryHookOptions<GetSensorGraphDefaultColorQuery, GetSensorGraphDefaultColorQueryVariables>) {
        return Apollo.useQuery<GetSensorGraphDefaultColorQuery, GetSensorGraphDefaultColorQueryVariables>(GetSensorGraphDefaultColorDocument, baseOptions);
      }
export function useGetSensorGraphDefaultColorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSensorGraphDefaultColorQuery, GetSensorGraphDefaultColorQueryVariables>) {
          return Apollo.useLazyQuery<GetSensorGraphDefaultColorQuery, GetSensorGraphDefaultColorQueryVariables>(GetSensorGraphDefaultColorDocument, baseOptions);
        }
export type GetSensorGraphDefaultColorQueryHookResult = ReturnType<typeof useGetSensorGraphDefaultColorQuery>;
export type GetSensorGraphDefaultColorLazyQueryHookResult = ReturnType<typeof useGetSensorGraphDefaultColorLazyQuery>;
export type GetSensorGraphDefaultColorQueryResult = Apollo.QueryResult<GetSensorGraphDefaultColorQuery, GetSensorGraphDefaultColorQueryVariables>;
export const GetSensorGraphColorByIdDocument = gql`
    query getSensorGraphColorById($colorId: String) {
  sensorGraphColors(
    where: {path: "sensorGraphColorId", comparison: equal, value: [$colorId]}
  ) {
    sensorGraphColorID
    name
    color
    isDefault
  }
}
    `;

/**
 * __useGetSensorGraphColorByIdQuery__
 *
 * To run a query within a React component, call `useGetSensorGraphColorByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSensorGraphColorByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSensorGraphColorByIdQuery({
 *   variables: {
 *      colorId: // value for 'colorId'
 *   },
 * });
 */
export function useGetSensorGraphColorByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetSensorGraphColorByIdQuery, GetSensorGraphColorByIdQueryVariables>) {
        return Apollo.useQuery<GetSensorGraphColorByIdQuery, GetSensorGraphColorByIdQueryVariables>(GetSensorGraphColorByIdDocument, baseOptions);
      }
export function useGetSensorGraphColorByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSensorGraphColorByIdQuery, GetSensorGraphColorByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetSensorGraphColorByIdQuery, GetSensorGraphColorByIdQueryVariables>(GetSensorGraphColorByIdDocument, baseOptions);
        }
export type GetSensorGraphColorByIdQueryHookResult = ReturnType<typeof useGetSensorGraphColorByIdQuery>;
export type GetSensorGraphColorByIdLazyQueryHookResult = ReturnType<typeof useGetSensorGraphColorByIdLazyQuery>;
export type GetSensorGraphColorByIdQueryResult = Apollo.QueryResult<GetSensorGraphColorByIdQuery, GetSensorGraphColorByIdQueryVariables>;
export const CostsPerCategoriesDocument = gql`
    query costsPerCategories($projectFileVersionId: Int) {
  costsPerCategories: costsPerCategories(
    projectFileVersionId: $projectFileVersionId
  ) {
    totalAmount
    priceAttributeType {
      unit
      dataType
    }
    categories {
      ...CostsValue
      children {
        ...CostsValue
        children {
          ...CostsValue
          children {
            ...CostsValue
            children {
              ...CostsValue
              children {
                ...CostsValue
              }
            }
          }
        }
      }
    }
  }
}
    ${CostsValueFragmentDoc}`;

/**
 * __useCostsPerCategoriesQuery__
 *
 * To run a query within a React component, call `useCostsPerCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostsPerCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostsPerCategoriesQuery({
 *   variables: {
 *      projectFileVersionId: // value for 'projectFileVersionId'
 *   },
 * });
 */
export function useCostsPerCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CostsPerCategoriesQuery, CostsPerCategoriesQueryVariables>) {
        return Apollo.useQuery<CostsPerCategoriesQuery, CostsPerCategoriesQueryVariables>(CostsPerCategoriesDocument, baseOptions);
      }
export function useCostsPerCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CostsPerCategoriesQuery, CostsPerCategoriesQueryVariables>) {
          return Apollo.useLazyQuery<CostsPerCategoriesQuery, CostsPerCategoriesQueryVariables>(CostsPerCategoriesDocument, baseOptions);
        }
export type CostsPerCategoriesQueryHookResult = ReturnType<typeof useCostsPerCategoriesQuery>;
export type CostsPerCategoriesLazyQueryHookResult = ReturnType<typeof useCostsPerCategoriesLazyQuery>;
export type CostsPerCategoriesQueryResult = Apollo.QueryResult<CostsPerCategoriesQuery, CostsPerCategoriesQueryVariables>;
export const GetProjectDocument = gql`
    query getProject($code: String) {
  projects: projects(where: {path: "code", comparison: equal, value: [$code]}) {
    projectID
    name
    code
    dataModel {
      dataModelID
    }
    projectExternals {
      externalID
      externalSystem {
        code
      }
    }
    projectFiles {
      projectFileID
      name
      fileName
      fileType {
        code
      }
      projectFileVersions(orderBy: {path: "version", descending: true}) {
        projectFileVersionID
        version
        projectFileVersionExternals {
          externalID
          externalSystem {
            code
          }
        }
        projectFileVersionViewables(orderBy: {path: "name"}) {
          projectFileVersionViewableID
          name
          viewableType
          projectFileVersionViewableExternals {
            externalID
            externalSystem {
              code
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, baseOptions);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, baseOptions);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;